/* eslint-disable unicorn/prefer-blob-reading-methods */
/* eslint-disable unicorn/prefer-add-event-listener */
function textPollyfill() {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = reject
        reader.readAsText(this)
    })
}

function arrayBufferPollyfill() {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as ArrayBuffer)
        reader.onerror = reject
        reader.readAsArrayBuffer(this)
    })
}

Blob.prototype.text = Blob.prototype.text || textPollyfill

Blob.prototype.arrayBuffer = Blob.prototype.arrayBuffer || arrayBufferPollyfill

File.prototype.text = File.prototype.text || textPollyfill
File.prototype.arrayBuffer = File.prototype.arrayBuffer || arrayBufferPollyfill
